import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const commonRoutes = [
	{
	    path: '/productintroduction',
	    name: 'productintroduction',
	    meta: { title: '进销存账单库存管理' },
	    component: () => import('../components/ProductIntroduction.vue'),
	},
    {
        path: '/login',
        name: 'login',
        meta: { title: '登录' },
        component: () => import('../components/Login.vue'),
    },
    {
        path: '/404',
        name: '404',
        meta: { title: '404' },
        component: () => import('../components/404.vue'),
    },
    { path: '/', redirect: '/home' },
	{
	    path: '/documentshare',
	    name: 'documentshare',
	    meta: { title: '单据分享' },
	    component: () => import('../components/DocumentShare.vue'),
	},
	{
	    path: '/supplierreconciliationlistshare',
	    name: 'supplierreconciliationlistshare',
	    meta: { title: '供应商对账单分享' },
	    component: () => import('../components/SupplierReconciliationListShare.vue'),
	},
	{
	    path: '/customerreconciliationlistshare',
	    name: 'customerreconciliationlistshare',
	    meta: { title: '客户对账单分享' },
	    component: () => import('../components/CustomerReconciliationListShare.vue'),
	},
]

// 本地所有的页面 需要配合后台返回的数据生成页面
export const asyncRoutes = {
    home: {
        path: 'home',
        name: 'home',
        meta: { title: '主页' },
        component: () => import('../views/Home/Home.vue'),
		children:[
			{
				path: 'auditlist',
				name: 'auditlist',
				meta: { title: '待审核单据' },
				component: () => import('../views/Home/AuditList.vue'),
			},
			{
				path: 'businessanalysis',
				name: 'businessanalysis',
				meta: { title: '经营分析' },
				component: () => import('../views/Home/BusinessAnalysis.vue'),
			},
			{
				path: 'uncollectedlist',
				name: 'uncollectedlist',
				meta: { title: '待收款单据' },
				component: () => import('../views/Home/UncollectedList.vue'),
			},
			{
				path: 'unpaidlist',
				name: 'unpaidlist',
				meta: { title: '待付款单据' },
				component: () => import('../views/Home/UnpaidList.vue'),
			},
			{
				path: 'printerpage',
				name: 'printerpage',
				meta: { title: '打印单据' },
				component: () => import('../components/PrinterPage.vue'),
			},
			{
				path: 'printercodepage',
				name: 'printercodepage',
				meta: { title: '打印条码' },
				component: () => import('../components/PrinterCodePage.vue'),
			},
			{
				path: 'printtemplatesettings',
				name: 'printtemplatesettings',
				meta: { title: '打印模版设置' },
				component: () => import('../components/PrintTemplateSettings.vue'),
			}
		]
    },

    //采购管理
    purchaseplanlist: {
        path: 'purchaseplanlist',
        name: 'purchaseplanlist',
        meta: { title: '采购订单' },
        component: () => import('../views/PurchaseManage/PurchasePlanList.vue'),
		children:[
			{
				path: 'purchaseplanlistfunc',
				name: 'purchaseplanlistfunc',
				meta: { title: '操作采购订单' },
				component: () => import('../views/PurchaseManage/PurchasePlanListFunc.vue'),
			},
			{
				path: 'purchaseplanlistdetail',
				name: 'purchaseplanlistdetail',
				meta: { title: '查看采购订单' },
				component: () => import('../components/PurchasePlanListDetail.vue'),
			}
		]
    },
    purchaselist: {
        path: 'purchaselist',
        name: 'purchaselist',
        meta: { title: '采购单' },
        component: () => import('../views/PurchaseManage/PurchaseList.vue'),
		children:[
			{
				path: 'purchaselistfunc',
				name: 'purchaselistfunc',
				meta: { title: '操作采购单' },
				component: () => import('../views/PurchaseManage/PurchaseListFunc.vue'),
			},
			{
				path: 'purchaselistdetail',
				name: 'purchaselistdetail',
				meta: { title: '查看采购单' },
				component: () => import('../components/PurchaseListDetail.vue'),
			}
		]
    },
    returnlist: {
        path: 'returnlist',
        name: 'returnlist',
        meta: { title: '采购退货单' },
        component: () => import('../views/PurchaseManage/ReturnList.vue'),
		children:[
			{
				path: 'returnlistfunc',
				name: 'returnlistfunc',
				meta: { title: '操作采购退货单' },
				component: () => import('../views/PurchaseManage/ReturnListFunc.vue'),
			},
			{
				path: 'returnlistdetail',
				name: 'returnlistdetail',
				meta: { title: '查看退货单' },
				component: () => import('../components/ReturnListDetail.vue'),
			}
		]
    },
    othercostlist: {
        path: 'othercostlist',
        name: 'othercostlist',
        meta: { title: '其它付款单' },
        component: () => import('../views/PurchaseManage/OtherCostList.vue'),
		children:[
			{
				path: 'othercostlistfunc',
				name: 'othercostlistfunc',
				meta: { title: '操作其它付款单' },
				component: () => import('../views/PurchaseManage/OtherCostListFunc.vue'),
			},
			{
				path: 'othercostlistdetail',
				name: 'othercostlistdetail',
				meta: { title: '查看其它付款单' },
				component: () => import('../components/OtherCostListDetail.vue')
			}
		]
    },

    //销售管理
    retaillist: {
        path: 'retaillist',
        name: 'retaillist',
        meta: { title: '零售开单' },
        component: () => import('../views/SalesManage/RetailList.vue'),
		children:[
			{
				path: 'retaillistfunc',
				name: 'retaillistfunc',
				meta: { title: '操作零售单' },
				component: () => import('../views/SalesManage/RetailListFunc.vue'),
			},
			{
				path: 'retaillistdetail',
				name: 'retaillistdetail',
				meta: { title: '查看零售单' },
				component: () => import('../components/RetailListDetail.vue'),
			}
		]
    },
    salesplanlist: {
        path: 'salesplanlist',
        name: 'salesplanlist',
        meta: { title: '销售订单' },
        component: () => import('../views/SalesManage/SalesPlanList.vue'),
		children:[
			{
				path: 'salesplanlistfunc',
				name: 'salesplanlistfunc',
				meta: { title: '操作销售订单' },
				component: () => import('../views/SalesManage/SalesPlanListFunc.vue'),
			},
			{
				path: 'salesplanlistdetail',
				name: 'salesplanlistdetail',
				meta: { title: '查看销售订单' },
				component: () => import('../components/SalesPlanListDetail.vue'),
			}
		]
    },
    saleslist: {
        path: 'saleslist',
        name: 'saleslist',
        meta: { title: '销售单' },
        component: () => import('../views/SalesManage/SalesList.vue'),
		children:[
			{
				path: 'saleslistfunc',
				name: 'saleslistfunc',
				meta: { title: '操作销售单' },
				component: () => import('../views/SalesManage/SalesListFunc.vue'),
			},
			{
				path: 'saleslistdetail',
				name: 'saleslistdetail',
				meta: { title: '查看销售单' },
				component: () => import('../components/SalesListDetail.vue'),
			}
		]
    },
    returnsaleslist: {
        path: 'returnsaleslist',
        name: 'returnsaleslist',
        meta: { title: '销售退货单' },
        component: () => import('../views/SalesManage/ReturnSalesList.vue'),
		children:[
			{
				path: 'returnsaleslistfunc',
				name: 'returnsaleslistfunc',
				meta: { title: '操作销售退货单' },
				component: () => import('../views/SalesManage/ReturnSalesListFunc.vue'),
			},
			{
				path: 'returnsaleslistdetail',
				name: 'returnsaleslistdetail',
				meta: { title: '查看销售退货单' },
				component: () => import('../components/ReturnSalesListDetail.vue'),
			}
		]
    },
    otherreceiptlist: {
        path: 'otherreceiptlist',
        name: 'otherreceiptlist',
        meta: { title: '其它收款单' },
        component: () => import('../views/SalesManage/OtherReceiptList.vue'),
		children:[
			{
				path: 'otherreceiptlistfunc',
				name: 'otherreceiptlistfunc',
				meta: { title: '操作其它收款单' },
				component: () => import('../views/SalesManage/OtherReceiptListFunc.vue'),
			},
			{
				path: 'otherreceiptlistdetail',
				name: 'otherreceiptlistdetail',
				meta: { title: '查看其它付款单' },
				component: () => import('../components/OtherReceiptListDetail.vue')
			}
		]
    },

    //财务管理
    paymentlist: {
        path: 'paymentlist',
        name: 'paymentlist',
        meta: { title: '付款单' },
        component: () => import('../views/FinanceManage/PaymentList.vue'),
		children:[
			{
				path: 'paymentlistfunc',
				name: 'paymentlistfunc',
				meta: { title: '操作付款单' },
				component: () => import('../views/FinanceManage/PaymentListFunc.vue'),
			},
			{
				path: 'paymentlistdetail',
				name: 'paymentlistdetail',
				meta: { title: '查看付款单' },
				component: () => import('../components/PaymentListDetail.vue')
			}
		]
    },
    receiptlist: {
        path: 'receiptlist',
        name: 'receiptlist',
        meta: { title: '收款单' },
        component: () => import('../views/FinanceManage/ReceiptList.vue'),
		children:[
			{
				path: 'receiptlistfunc',
				name: 'receiptlistfunc',
				meta: { title: '操作收款单' },
				component: () => import('../views/FinanceManage/ReceiptListFunc.vue'),
			},
			{
				path: 'receiptlistdetail',
				name: 'receiptlistdetail',
				meta: { title: '查看收款单' },
				component: () => import('../components/ReceiptListDetail.vue')
			}
		]
    },
	constomerreconciliationlist: {
	    path: 'constomerreconciliationlist',
	    name: 'constomerreconciliationlist',
	    meta: { title: '客户对账单' },
	    component: () => import('../views/FinanceManage/CustomerReconciliationList.vue')
	},
	supplierreconciliationlist: {
	    path: 'supplierreconciliationlist',
	    name: 'supplierreconciliationlist',
	    meta: { title: '供应商对账单' },
	    component: () => import('../views/FinanceManage/SupplierReconciliationList.vue')
	},
	
    //库存管理
    commodityallocationlist: {
        path: 'commodityallocationlist',
        name: 'commodityallocationlist',
        meta: { title: '商品调拨单' },
        component: () => import('../views/StockManage/CommodityAllocationList.vue'),
		children:[
			{
				path: 'commodityallocationlistfunc',
				name: 'commodityallocationlistfunc',
				meta: { title: '操作商品调拨单' },
				component: () => import('../views/StockManage/CommodityAllocationListFunc.vue'),
			},
			{
				path: 'commodityallocationlistdetail',
				name: 'commodityallocationlistdetail',
				meta: { title: '查看商品调拨单' },
				component: () => import('../components/CommodityAllocationListDetail.vue')
			}
		]
    },
    commoditycostadjustlist: {
        path: 'commoditycostadjustlist',
        name: 'commoditycostadjustlist',
        meta: { title: '成本调整单' },
        component: () => import('../views/StockManage/CommodityCostAdjustList.vue'),
		children:[
			{
				path: 'commoditycostadjustlistfunc',
				name: 'commoditycostadjustlistfunc',
				meta: { title: '操作成本调整单' },
				component: () => import('../views/StockManage/CommodityCostAdjustListFunc.vue'),
			},
			{
				path: 'commoditycostadjustlistdetail',
				name: 'commoditycostadjustlistdetail',
				meta: { title: '查看成本调整单' },
				component: () => import('../components/CommodityCostAdjustListDetail.vue')
			}
		]
    },
    enterstorelist: {
        path: 'enterstorelist',
        name: 'enterstorelist',
        meta: { title: '其它入库单' },
        component: () => import('../views/StockManage/EnterStoreList.vue'),
		children:[
			{
				path: 'enterstorelistfunc',
				name: 'enterstorelistfunc',
				meta: { title: '操作其它入库单' },
				component: () => import('../views/StockManage/EnterStoreListFunc.vue'),
			},
			{
				path: 'enterstorelistdetail',
				name: 'enterstorelistdetail',
				meta: { title: '查看其它入库单' },
				component: () => import('../components/EnterStoreListDetail.vue')
			}
		]
    },
    outstorelist: {
        path: 'outstorelist',
        name: 'outstorelist',
        meta: { title: '其它出库单' },
        component: () => import('../views/StockManage/OutStoreList.vue'),
		children:[
			{
				path: 'outstorelistfunc',
				name: 'outstorelistfunc',
				meta: { title: '操作其它出库单' },
				component: () => import('../views/StockManage/OutStoreListFunc.vue'),
			},
			{
				path: 'outstorelistdetail',
				name: 'outstorelistdetail',
				meta: { title: '查看其它出库单' },
				component: () => import('../components/OutStoreListDetail.vue')
			}
		]
    },
    inventorysheet: {
        path: 'inventorysheet',
        name: 'inventorysheet',
        meta: { title: '商品盘点单' },
        component: () => import('../views/StockManage/InventorySheet.vue'),
		children:[
			{
				path: 'inventorysheetfunc',
				name: 'inventorysheetfunc',
				meta: { title: '操作商品盘点单' },
				component: () => import('../views/StockManage/InventorySheetFunc.vue'),
			},
			{
				path: 'inventorysheetdetail',
				name: 'inventorysheetdetail',
				meta: { title: '查看商品盘点单' },
				component: () => import('../components/InventorySheetDetail.vue')
			}
		]
    },
    splitlist: {
        path: 'splitlist',
        name: 'splitlist',
        meta: { title: '组装拆卸单' },
        component: () => import('../views/StockManage/SplitList.vue'),
		children:[
			{
				path: 'splitlistfunc',
				name: 'splitlistfunc',
				meta: { title: '操作组装拆卸单' },
				component: () => import('../views/StockManage/SplitListFunc.vue'),
			},
			{
				path: 'splitlistdetail',
				name: 'splitlistdetail',
				meta: { title: '查看组装拆卸单' },
				component: () => import('../components/SplitListDetail.vue')
			}
		]
    },
    //基础数据
    commoditymanage: {
        path: 'commoditymanage',
        name: 'commoditymanage',
        meta: { title: '商品信息' },
        component: () => import('../views/BaseInfo/CommodityManage.vue'),
		children:[
			{
				path: 'commodityfunc',
				name: 'commodityfunc',
				meta: { title: '操作商品' },
				component: () => import('../views/BaseInfo/CommodityFunc.vue'),
			},
			{
				path: 'commoditydetailinfo',
				name: 'commoditydetailinfo',
				meta: { title: '查看商品' },
				component: () => import('../components/CommodityDetailInfo.vue'),
			}
		]
    },
	
    commoditypackage: {
        path: 'commoditypackage',
        name: 'commoditypackage',
        meta: { title: '套餐商品' },
        component: () => import('../views/BaseInfo/CommodityPackage.vue'),
		children:[
			{
				path: 'packagefunc',
				name: 'packagefunc',
				meta: { title: '操作套餐' },
				component: () => import('../views/BaseInfo/PackageFunc.vue'),
			},
			{
				path: 'packagedetailinfo',
				name: 'packagedetailinfo',
				meta: { title: '查看套餐' },
				component: () => import('../components/PackageDetailInfo.vue'),
			}
		]
    },
    depotmanage: {
        path: 'depotmanage',
        name: 'depotmanage',
        meta: { title: '仓库信息' },
        component: () => import('../views/BaseInfo/DepotManage.vue'),
    },
    suppliermanage: {
        path: 'suppliermanage',
        name: 'suppliermanage',
        meta: { title: '供应商信息' },
        component: () => import('../views/BaseInfo/SupplierManage.vue'),
    },
    customermanage: {
        path: 'customermanage',
        name: 'customermanage',
        meta: { title: '客户信息' },
        component: () => import('../views/BaseInfo/CustomerManage.vue'),
    },

    //系统管理
    menumanage: {
        path: 'menumanage',
        name: 'menumanage',
        meta: { title: '菜单管理' },
        component: () => import('../views/SystemManage/MenuManage.vue'),
    },
    iconmanage: {
        path: 'iconmanage',
        name: 'iconmanage',
        meta: { title: '图标管理' },
        component: () => import('../views/SystemManage/IconManage.vue'),
    },
    iconlibrary: {
        path: 'iconlibrary',
        name: 'iconlibrary',
        meta: { title: '图标库' },
        component: () => import('../components/IconLibrary.vue'),
    },
    usermanage: {
        path: 'usermanage',
        name: 'usermanage',
        meta: { title: '用户信息' },
        component: () => import('../views/SystemManage/UserManage.vue'),
    },
    rolemanage: {
        path: 'rolemanage',
        name: 'rolemanage',
        meta: { title: '角色信息' },
        component: () => import('../views/SystemManage/RoleManage.vue'),
    },
    workshopmanage: {
        path: 'workshopmanage',
        name: 'workshopmanage',
        meta: { title: '店铺信息' },
        component: () => import('../views/SystemManage/StoreManage.vue'),
    },
    functionmanage: {
        path: 'functionmanage',
        name: 'functionmanage',
        meta: { title: '功能项管理' },
        component: () => import('../views/SystemManage/FunctionManage.vue'),
    },
    systemsettings: {
        path: 'systemsettings',
        name: 'systemsettings',
        meta: { title: '系统配置' },
        component: () => import('../views/SystemManage/SystemSettings.vue'),
    },
}

const createRouter = () => new Router({
    routes: commonRoutes,
})

const router = createRouter()

export function resetRouter() {
    const newRouter = createRouter()
    router.matcher = newRouter.matcher
}

export default router
